import { memo } from "react";
import Question from "../Question/Question";

const DatePicker = ({
  index,
  id,
  disabled,
  label,
  description,
  onChange,
  required,
  reOrder,
  onRemove,
  formContainer,
  duplicateQuestion,
  question_number,
}) => {
  return (
    <Question
      question_number={question_number}
      formContainer={formContainer}
      duplicateQuestion={duplicateQuestion}
      disabled={disabled}
      onChange={onChange}
      description={description}
      label={label}
      index={index}
      id={id}
      required={required}
      reOrder={reOrder}
      onRemove={onRemove}
      field_type="date"
      type={"تاریخ"}
    ></Question>
  );
};
export default memo(DatePicker);
